var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormatAlignLeft = function SvgFormatAlignLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "format_align_left_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#format_align_left_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 21a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 20q0-.424.288-.712A.97.97 0 0 1 4 19h16q.424 0 .712.288.288.287.288.712 0 .424-.288.712A.97.97 0 0 1 20 21zm0-4a.97.97 0 0 1-.712-.288A.97.97 0 0 1 3 16q0-.424.288-.713A.97.97 0 0 1 4 15h10q.424 0 .713.287.287.288.287.713 0 .424-.287.712A.97.97 0 0 1 14 17zm0-4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 12q0-.424.288-.713A.97.97 0 0 1 4 11h16q.424 0 .712.287.288.288.288.713 0 .424-.288.713A.97.97 0 0 1 20 13zm0-4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 8q0-.424.288-.713A.97.97 0 0 1 4 7h10q.424 0 .713.287Q15 7.576 15 8q0 .424-.287.713A.97.97 0 0 1 14 9zm0-4a.97.97 0 0 1-.712-.287A.97.97 0 0 1 3 4q0-.424.288-.712A.97.97 0 0 1 4 3h16q.424 0 .712.288Q21 3.575 21 4q0 .424-.288.713A.97.97 0 0 1 20 5z"
  }))));
};
export default SvgFormatAlignLeft;